import * as _ from 'node_modules/underscore/underscore.js';

// based on example from w3.org
// https://www.w3.org/TR/wai-aria-practices-1.1/examples/tabs/tabs-2/js/tabs.js

export default class researchProject
{
    constructor()
    {
        // For easy reference
        this.keys = {
            end:    35,
            home:   36,
            left:   37,
            up:     38,
            right:  39,
            down:   40,
            delete: 46,
            enter:  13,
            space:  32
        };
        this.direction = {
            37: -1,
            38: -1,
            39: 1,
            40: 1
        };

        this.currentPanel = 'introTab';
        this.panelsArray = [];
        this.panels = $('.research-project-sections-container-js section');
        this.tabs = $('.section-controls-js button');
        this.blockQuotes = $('.blockquote-container-js');

        // dynamic tabs call for dynamic arrays tracking the tabs
        this.tabs.each((index, element) => {
            this.panelsArray.push($(element).attr('aria-controls'));
        });

        this._adjustBlockQuoteStyle();
        this.tabs.click(event => this._tabClickListener(event));
        this.tabs.keydown(event => this._tabKeydownListener(event));
        this.tabs.keyup(event => this._tabKeyupListener(event));
    }

    _tabClickListener(event)
    {
        if (event.target.getAttribute('aria-controls') !== this.currentPanel) {
            this._activateTab($(event.target), false);
        }
    }

    _tabKeydownListener(event)
    {
        let key = event.keyCode;

        switch (key) {
            case this.keys.end:
                event.preventDefault();
                this._focusLastTab();
                break;
            case this.keys.home:
                event.preventDefault();
                this._focusFirstTab();
                break;

            // Up and Down keys are handled here to prevent page scroll
            case this.keys.up:
            case this.keys.down:
                this._determineOrientation(event);
                break;
        }
    }

    _tabKeyupListener(event)
    {
        let key = event.keyCode;

        switch (key) {
            case this.keys.left:
            case this.keys.right:
                this._determineOrientation(event);
                break;
            case this.keys.enter:
            case this.keys.space:
                this._activateTab($(event.target));
                break;
        }
    }

    // When a tablist's aria-orientation is set to vertical,
    // only up and down arrow should function.
    // In all other cases only left and right arrow function.
    _determineOrientation (event) {
        let key = event.keyCode;
        let vertical = $(this.tabs[0]).parent().attr('aria-orientation') === 'vertical';
        let proceed = false;

        if (vertical) {
            if (key === this.keys.up || key === this.keys.down) {
                event.preventDefault();
                proceed = true;
            }
        } else {
            if (key === this.keys.left || key === this.keys.right) {
                proceed = true;
            }
        }

        if (proceed) {
            this._switchTabOnArrowPress(event);
        }
    }

    _switchTabOnArrowPress(event)
    {
        let key = event.keyCode;

        if (this.direction[key]) {
            let target = $(event.target).attr('aria-controls');

            if (this.panelsArray.indexOf(target) !== undefined) {
                let newIndex = this.panelsArray.indexOf(target) + this.direction[key];

                // if a tab exists in the direction of button pressed, just switch to that
                if (this.panelsArray[newIndex]) {
                    $('button[aria-controls="'+this.panelsArray[newIndex]+'"]').focus();

                // otherwise, wrap to the beginning/end of tablist
                } else if (key === this.keys.left || key === this.keys.up) {
                    this._focusLastTab();
                } else if (key === this.keys.right || key === this.keys.down) {
                    this._focusFirstTab();
                }
            }
        }
    }

    _activateTab($tab, setFocus)
    {
        setFocus = setFocus || true;
        // Deactivate all other tabs.  Use callback to wait for animation to finish
        this._deactivateTabs(() => {
            // Remove tabindex attribute && Set the tab as selected
            $tab.removeAttr('tabindex').attr('aria-selected', 'true').addClass('selected');

            // Get the value of aria-controls (which is an ID)
            this.currentPanel = $tab.attr('aria-controls');
            let $newPanel = $('#' + this.currentPanel);

            // Remove hidden attribute from tab panel to make it visible
            // Prime the element for .fadeIn animation
            $newPanel.removeAttr('hidden').css('opacity', '0');

            // switch tab & animate
            $newPanel.parent().css('height', $newPanel.outerHeight());

            $newPanel.fadeTo(400, 1, () => {
                // Set focus when required
                if (setFocus) {
                    $tab.focus();
                }

                this._adjustBlockQuoteStyle();
                $newPanel.parent().css('height', '');
            });
        });
    }

    _deactivateTabs(_callback)
    {
        // tab accessibility
        this.tabs.attr('tabindex', '-1').attr('aria-selected', 'false').removeClass('selected');

        // fade out panel
        $(this.panels.get(
            this.panelsArray.indexOf(this.currentPanel)
        )).fadeOut(200, () => {
            this.panels.attr('hidden', 'hidden');
            _callback();
        });
    }

    _focusFirstTab()
    {
        $(this.tabs[0]).focus();
    }

    _focusLastTab()
    {
        $(this.tabs[this.tabs.length - 1]).focus();
    }

    _adjustBlockQuoteStyle()
    {
        if (!this.blockQuotes.length) {
            return;
        }

        let that = this;

        function doResize() {
            that.blockQuotes.each(function () {
                $(this).parent().css(
                    'padding-bottom',
                    $(this).outerHeight() + 20
                );
            });
        }

        $(window).resize(_.debounce(() => {
            doResize();
        }, 400));

        doResize();
    }
}
